
const pattern = /^(https?:\/\/)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=,]*)/;

export function findUrl(text) {
	const match = pattern.exec(text);
	return match ? match[0] : null;
}



// WEBPACK FOOTER //
// ./lib/helpers/findUrl.js